import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const EditFreelancerSkeleton = () => {
   return (
      <div className="min-h-screen">
         <div className="mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {/* Botón de retroceso */}
            <div className="flex items-center mb-6">
               <Skeleton circle width={24} height={24} className="mr-2" />
               <Skeleton width={80} height={24} />
            </div>

            <div className="rounded-lg overflow-hidden">
               {/* Encabezado */}
               <div className="px-6 py-4 text-center">
                  <Skeleton height={32} className="mx-auto" style={{ maxWidth: '300px' }} />
               </div>

               <div className="p-6 md:p-8 flex flex-col md:flex-row gap-8">
                  {/* Sección de imagen de perfil */}
                  <div className="w-full md:w-1/3 lg:w-1/4 flex flex-col items-center">
                     <div className="relative mb-4">
                        <Skeleton circle width={192} height={192} />
                     </div>

                     <div className="w-full mt-4">
                        <Skeleton width={120} height={20} className="mb-2" />
                        <Skeleton height={36} borderRadius={9999} />
                     </div>
                  </div>

                  {/* Sección de formulario */}
                  <div className="w-full md:w-2/3 lg:w-3/4">
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Campos del formulario */}
                        {[...Array(18)].map((_, index) => (
                           <div key={index}>
                              <Skeleton width={120} height={20} className="mb-1" />
                              <Skeleton width={400} height={40} />
                           </div>
                        ))}

                        {/* Mapa */}
                        <div className="col-span-1 md:col-span-2">
                           <Skeleton width={180} height={20} className="mb-2" />
                           <Skeleton height={256} />
                           <Skeleton width={300} height={16} className="mt-2" />
                        </div>

                        {/* Acerca de ti */}
                        <div className="col-span-1 md:col-span-2">
                           <Skeleton width={100} height={20} className="mb-1" />
                           <Skeleton height={160} />
                           <Skeleton width={150} height={16} className="mt-1" />
                        </div>

                        {/* Idiomas */}
                        <div className="col-span-1 md:col-span-2">
                           <Skeleton width={180} height={20} className="mb-1" />
                           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                              {[...Array(8)].map((_, index) => (
                                 <div key={index} className="flex items-center">
                                    <Skeleton circle width={16} height={16} className="mr-2" />
                                    <Skeleton width={80} height={16} />
                                 </div>
                              ))}
                           </div>
                        </div>

                        {/* Redes sociales */}
                        <div className="col-span-1 md:col-span-2 mt-8">
                           <div className="flex items-center my-6">
                              <div className="flex-1">
                                 <Skeleton height={1} />
                              </div>
                              <Skeleton width={150} height={20} className="mx-4" />
                              <div className="flex-1">
                                 <Skeleton height={1} />
                              </div>
                           </div>

                           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                              {[...Array(4)].map((_, index) => (
                                 <div key={index}>
                                    <Skeleton width={100} height={20} className="mb-1" />
                                    <Skeleton height={40} />
                                 </div>
                              ))}
                           </div>
                        </div>

                        {/* Portafolio */}
                        <div className="col-span-1 md:col-span-2">
                           <Skeleton width={140} height={20} className="mb-1" />
                           <Skeleton height={40} />
                        </div>
                     </div>

                     {/* Botón de guardar */}
                     <div className="mt-10 flex justify-center">
                        <Skeleton height={48} borderRadius={8} style={{ width: '50%', maxWidth: '200px' }} />
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default EditFreelancerSkeleton;


